/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectCompany, getCompany } from "../../../../reducers/companySlice";
import {
  createMailChimp,
  deleteMailChimp,
  getMailChimp,
  updateMailChimp,
} from "../../../../utils/services/company";
import { useDispatch } from "react-redux";
import {
  selectLoadingUI,
  loadingOn,
  loadingOff,
} from "../../../../reducers/uiSlice";
import { Notification } from "../../../../containers/notification";
import { useSnackbar } from "notistack";
import {
  selectChangesDeposit,
  setChanges,
} from "../../../../reducers/depositSlice";
import { useChangeRecord } from "../../../../utils/hooks/useChangeRecord";
import dateUtils from "../../../../utils/date";
import { useNavigate } from "react-router-dom";

// CSS

import styles from "./styles.module.css";

//MATERIAL
import InputComponent from "../../../inputs";
import Toolbar from "../../../card/toolbar";
import jwt from "jsonwebtoken";
import config from "../../../../utils/config";
// import { Checkbox } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const logo = "https://luma-photos.s3.amazonaws.com/content/mailchimp.svg";

export default function MailChimpComponent() {
  const [apiKey, setApiKey] = useState("");
  const [updated, setUpdated] = useState(false);
  const [found, setFound] = useState(false);
  const company = useSelector(selectCompany);
  const loading = useSelector(selectLoadingUI);
  const changes = useSelector(selectChangesDeposit);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { recordChange } = useChangeRecord();

  useEffect(() => {
    if (company && company._id !== "") initialize();
  }, [company]);

  const initialize = async () => {
    setFound(false);
    const found = await getMailChimp(company._id).catch((err) => {
      console.log(err);
      return null;
    });
    setApiKey("");

    if (found) {
      if (found.apiKey) {
        setApiKey(jwt.verify(found.apiKey, config.jwtSecret));
        setFound(!!found);
      }
    }
  };

  const updateChanges = (fieldName, newValue) => {
    const newChanges = [];
    newChanges.push(...changes);
    var index = -1;
    const change = {
      text: "",
      oldValue: null,
      newValue: null,
      date: dateUtils.getUTC().slice(0, 19).replace("T", " "),
    };

    change.newValue = newValue;
    change.oldValue = company && company[fieldName] ? company[fieldName] : "";

    switch (fieldName) {
      case "apiKey":
        change.text = "Cambios en el apiKey de mailchimp";
        break;
      default:
        break;
    }

    index = newChanges.findIndex(
      (item) => item.text.toString() === change.text.toString()
    );

    if (index !== -1) {
      change.oldValue = newChanges[index].oldValue;
      newChanges[index] = change;
    } else {
      newChanges.push(change);
    }
    dispatch(setChanges(newChanges));
  };

  const handleCancel = () => initialize();

  const handleSave = async () => {
    dispatch(loadingOn());
    const found = await getMailChimp(company._id).catch((err) => {
      console.log(err);
      return null;
    });
    if (found && found.apiKey)
      updateMailChimp({
        companyId: company._id,
        apiKey: jwt.sign(apiKey, config.jwtSecret),
      })
        .then((res) => {
          dispatch(loadingOff());
          getCompany(company._id, dispatch);
          enqueueSnackbar(
            Notification({
              text: "Datos de la tienda actualizados",
              variant: "success",
              withDetails: false,
            })
          );
          setUpdated(false);
          recordChange({
            module: "Configuraciones",
            submodule: "Mailchimp",
            changes: changes,
          }).catch((err) => console.log(err));
        })
        .catch((err) => {
          enqueueSnackbar(
            Notification({
              text: "Error al actualizar datos de la tienda",
              variant: "error",
              withDetails: false,
            })
          );
          dispatch(loadingOff());
        });
    else
      createMailChimp({
        companyId: company._id,
        apiKey: jwt.sign(apiKey, config.jwtSecret),
      })
        .then((res) => {
          dispatch(loadingOff());
          getCompany(company._id, dispatch);
          enqueueSnackbar(
            Notification({
              text: "Datos de la tienda actualizados",
              variant: "success",
              withDetails: false,
            })
          );
          setUpdated(false);
          recordChange({
            module: "Configuraciones",
            submodule: "Mailchimp",
            changes: changes,
          }).catch((err) => console.log(err));
        })
        .catch((err) => {
          enqueueSnackbar(
            Notification({
              text: "Error al actualizar datos de la tienda",
              variant: "error",
              withDetails: false,
            })
          );
          dispatch(loadingOff());
        });
  };

  const handleRemove = async () => {
    dispatch(loadingOn());

    deleteMailChimp(company._id)
      .then(async (res) => {
        dispatch(loadingOff());
        getCompany(company._id, dispatch);
        await initialize();
        enqueueSnackbar(
          Notification({
            text: "Datos de la tienda actualizados",
            variant: "success",
            withDetails: false,
          })
        );
        setUpdated(false);
        setFound(false);
        recordChange({
          module: "Configuraciones",
          submodule: "Mailchimp",
          changes: changes,
        }).catch((err) => console.log(err));
      })
      .catch((err) => {
        enqueueSnackbar(
          Notification({
            text: "Error al actualizar datos de la tienda",
            variant: "error",
            withDetails: false,
          })
        );
        dispatch(loadingOff());
      });
  };
  const handleClose = () => {
    navigate(-1);
  };

  return (
    <div className={styles.parentContainer}>
      <button className={styles.backButton} onClick={() => handleClose()}>
        <span>
          <ArrowBackIcon />
        </span>
        Regresar
      </button>
      <div className={styles.infoContainer}>
        <div className={styles.titleLogoContainer}>
          <Toolbar title="MailChimp" />
          <img src={logo} alt="logo" className={styles.imageElement} />
        </div>
        <div className={styles.infoDataContainer}>
          <p className={styles.textDescription}>
            Con MailChimp, tendrás la capacidad de enviar correos masivos a
            todos los clientes de NubeFood. Podrás informarles sobre los
            cupones, promociones y ofertas que estén disponibles en tu sitio
            web. Además, podrás enviar recordatorios por correo electrónico a
            aquellos clientes que hayan abandonado su carrito de compra sin
            finalizarla.
          </p>
          <div className={styles.inputStackContainer}>
            <div className={styles.inputContainer}>
              <label className={styles.labelInput}>ApiKey</label>

              <InputComponent
                placeholder=""
                type="text"
                handler={(e) => {
                  setApiKey(e.target.value);
                  updateChanges("apiKey", e.target.value);
                  setUpdated(true);
                }}
                disabled={loading}
                validation={apiKey === ""}
                value={apiKey}
              />
            </div>
            <div className={styles.buttonsContainer}>
              {apiKey !== "" && found && (
                <button
                  onClick={() => {
                    handleRemove();
                  }}
                  className={styles.deleteButton}
                >
                  Eliminar
                </button>
              )}
              <button
                disabled={!updated}
                onClick={() => {
                  setUpdated(true);
                  handleCancel();
                }}
                className={styles.cancelButton}
              >
                Cancelar
              </button>
              <button
                disabled={!updated}
                className={styles.confirmButton}
                onClick={() => {
                  setUpdated(true);
                  handleSave();
                }}
              >
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
